import React from 'react'
import "./css/Next.css"
import { FcNext,FcPrevious} from 'react-icons/fc'
import AOS from 'aos';
AOS.init();
function Next({name,href,back,href2,isAbout,islast}) {
    return (
       
        <section className="last_section">
         {isAbout ?<a data-aos="fade-right"  
        data-aos-duration="3000" className="next" href={href2}>
        <FcPrevious className="icon"/>
            <h2>To {back}</h2>
            

        </a>:null}

        {islast ?<a data-aos="fade-right"  
        data-aos-duration="3000" className="next" href={href}>
        <h2>To {name}</h2>
        <FcNext className="icon"/>
           
            

        </a>:null}
        
        

    </section>
    )
}

export default Next
